














































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import { SearchCondition, ScoreChangeLog } from "../../modules/teacher/ScoreChangeLogList"

export interface Data {
  condition: SearchCondition
  scoreChangeLogs: ScoreChangeLog[]
  totalCount: number
  fields: any[]
  isShow: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      scoreChangeLogs: new Array<ScoreChangeLog>(),
      totalCount: 0,
      fields: [
        {key: "sheet_id", label: "試験ID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "sheet_code", label: "試験CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "sheet_name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "room_name", label: "教室", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_name", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_code", label: "生徒CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_name", label: "生徒名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "before_score", label: "得点(変更前)", sortable: true, class: 'text-center b-table-th-td'},
        {key: "after_score", label: "得点(変更後)", sortable: true, class: 'text-center b-table-th-td'},
        {key: "aggregated_at", label: "集計日時", class: 'text-center b-table-th-td'},
        {key: "capture_date", label: "取込日", class: 'text-center b-table-th-td'},
      ],
      isShow: false,
      errors: [],
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {

      if(!state.condition.aggregated_at_from || !state.condition.aggregated_at_to){
        alert("集計日時を入力して下さい。");
        return;
      }
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/score_change_log_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.scoreChangeLogs = response.data.score_change_logs.map((x: any) => new ScoreChangeLog(x));
        state.totalCount = state.scoreChangeLogs.length > 0 ? state.scoreChangeLogs[0].full_count : 0;
        state.isShow = true;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      if(!state.condition.aggregated_at_from || !state.condition.aggregated_at_to){
        alert("集計日時を入力して下さい。");
        return;
      }

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/score_change_log_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `得点変更ログ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
    });

    return {
      ...toRefs(state),
      searchClick,
      search,
      clearCondition,
      changePage,
      download,
    };
  }
});
